import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Subject from '@mui/icons-material/Subject';
import ViewColumn from '@mui/icons-material/ViewColumn';
import { DiffViewMode, AuditDisplaySettings } from '../types';

interface ViewModeButtonsProps {
  displaySettings: AuditDisplaySettings;
  setDisplaySettings: React.Dispatch<React.SetStateAction<AuditDisplaySettings>>;
}

const VIEW_MODE_CONFIG: { mode: DiffViewMode; label: string; icon: React.ReactNode }[] = [
  { mode: 'sideBySide', label: 'Side by Side', icon: <ViewColumn fontSize='small' /> },
  { mode: 'naturalLanguage', label: 'Summary', icon: <Subject fontSize='small' /> },
];

export const ViewModeButtons: React.FC<ViewModeButtonsProps> = ({ displaySettings, setDisplaySettings }) => {
  const handleViewModeChange = (_event: React.MouseEvent<HTMLElement>, mode: DiffViewMode | null) => {
    // `exclusive` hands back null when the active button is clicked again; keep the current mode.
    if (!mode) return;
    setDisplaySettings((prev) => ({ ...prev, viewMode: mode }));
  };

  return (
    <ToggleButtonGroup exclusive size='small' value={displaySettings.viewMode} onChange={handleViewModeChange}>
      {VIEW_MODE_CONFIG.map(({ mode, label, icon }) => (
        <ToggleButton key={mode} value={mode} title={label} sx={{ gap: 0.75, textTransform: 'none' }}>
          {icon}
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
